exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resident-table .data-table--body .warning-icon:first-of-type{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.resident-table .data-table--body .warning-icon:first-of-type:before{content:url(\"/images/exclamation-solid.svg\");width:15px;height:15px;margin-right:8px;-webkit-filter:invert(.5) sepia(1) saturate(4) hue-rotate(5deg);filter:invert(.5) sepia(1) saturate(4) hue-rotate(5deg)}.resident-table .data-table .data-table_7.data-table_has-options>.data-table--row{grid-template-columns:1.25fr 1fr .5fr 1fr 1fr 1fr .75fr 100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15e93b67","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/residents/ResidentList.vue
// module id = G5Yt
// module chunks = 0 1